// src/auth/AuthProvider.js
import React, { createContext, useContext, useEffect, useState } from "react";
import userManager from "./UserManager";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    userManager
      .getUser()
      .then((u) => {
        setUser(u);
        if (u) {
          axios.defaults.headers.common.Authorization = `Bearer ${u.access_token}`;
          console.log("Access token set on default");
        } else {
        }
      })
      .catch(() => setUser(null));
    userManager.events.addUserLoaded(setUser);
    userManager.events.addUserUnloaded(() => setUser(null));

    return () => {
      userManager.events.removeUserLoaded(setUser);
      userManager.events.removeUserUnloaded(() => setUser(null));
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
};

/** @property {object} user */
export const useAuth = () => useContext(AuthContext);
